export default "__VITE_ASSET__DLg$8OqE__"